import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getEquipmentRegistrations: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_REGISTRATIONS].GET_EQUIPMENT_REGISTRATIONS,
	},
	getEquipmentRegistration: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_REGISTRATIONS].GET_EQUIPMENT_REGISTRATION,
	},
	createEquipmentRegistration: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_REGISTRATIONS].CREATE_EQUIPMENT_REGISTRATION,
	},
	patchEquipmentRegistration: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_REGISTRATIONS].PATCH_EQUIPMENT_REGISTRATION,
	},
	putEquipmentRegistration: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_REGISTRATIONS].PUT_EQUIPMENT_REGISTRATION,
	},
	deleteEquipmentRegistration: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_REGISTRATIONS].DELETE_EQUIPMENT_REGISTRATION,
	},
}
